import React, { useState, useEffect } from 'react';
import { Col, Row } from 'antd';
import {
  HomeFilled,
  InfoCircleOutlined,
  PhoneFilled,
  LogoutOutlined
} from '@ant-design/icons';
import Logo from '../assets/logotipo.png';
import DiarioAlimentar from '../assets/icon_diario_alimentar.png';
import ConsultarAlimentos from '../assets/icon_consultar-alimentos.png';
import CadastrarExames from '../assets/icon_cadastrar_exames.png';
import CalcularReceitas from '../assets/icon_calcular_receitas.png';
import Relatorios from '../assets/icon_relatorios.png';
import LembretesFormula from '../assets/icon_lembretes_de_formula.png';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import DehazeIcon from '@mui/icons-material/Dehaze';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom'
import { getDiagnostico, getNutrientesDiagnostico, getUserData, updateUserData, updateNutrientesData } from '../service/api';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

import './Home.scss';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  color: '#555555',
};

const Home = () => {
  let navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openModalNutrientes, setOpenModalNutrientes] = useState(false);
  const [defaultAltura, setDefaultAltura] = useState("");
  const [defaultPeso, setDefaultPeso] = useState("");
  const [newAltura, setNewAltura] = useState("");
  const [newPeso, setNewPeso] = useState("");
  const [userId, setUserId] = useState("");
  const [openAlert, setOpenAlert] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [nutrientesInfo, setNutrientesInfo] = useState([])

  useEffect(() => {
    const userId = localStorage.getItem('userId')
    setUserId(userId)
    if (!userId) {
      navigate('/login', { replace: true })
    }

    const loadDiagnostico = async (userId) => {
      await getDiagnostico(userId)
        .then(async response => {
          const doenca = response[0]
          let doencaData = {
            'doencaId': doenca.doencaid,
            'nome': doenca.registrodiagnosticoid
          }
          localStorage.setItem('doenca', JSON.stringify(doencaData))
          console.log(doenca.registrodiagnosticoid)
          await getNutrientesDiagnostico(userId).then(resp => {
            var nutrientesData = resp.map(function (item, i) {
              return {
                'nutrienteid': item.registrodiagnosticonutid,
                'quantidade': item.recomendacaodiaria,
                'nome': item.nomenutriente
              }
            })
            localStorage.setItem('nutrientes', JSON.stringify(nutrientesData))
            console.log(nutrientesData)
            setNutrientesInfo(nutrientesData)
          })
            .catch(function (error) {
              console.log(error)
              return []
            });
          return response
        })
        .catch(function (error) {
          console.log(error)
          return []
        });
    }

    var doenca = JSON.parse(localStorage.getItem('doenca'))
    if (!doenca) {
      loadDiagnostico(userId)
    }
  }, [])

  const onClickMenu = (path) => {
    navigate(path, { replace: true });
  }

  const Logout = () => {
    localStorage.removeItem('userId')
    navigate('/login', { replace: true });
  }

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenModal = async () => {
    await getUserData(userId)
      .then(response => {
        setDefaultAltura(response[0].user_height)
        setDefaultPeso(response[0].user_weight)
        setNewAltura(response[0].user_height)
        setNewPeso(response[0].user_weight)
      })
      .catch(function (error) {
        console.log(error)
      })

    setOpenModal(true);
    setAnchorEl(null);
  };
  const handleCloseModal = () => setOpenModal(false);

  const handleOpenModalNutrientes = async () => {
    await getNutrientesDiagnostico(userId).then(resp => {
      var nutrientesData = resp.map(function (item, i) {
        return {
          'nutrienteid': item.registrodiagnosticonutid,
          'quantidade': item.recomendacaodiaria,
          'nome': item.nomenutriente
        }
      })
      localStorage.setItem('nutrientes', JSON.stringify(nutrientesData))
      console.log(nutrientesData)
      setNutrientesInfo(nutrientesData)
    })
      .catch(function (error) {
        console.log(error)
        return []
      });
    console.log(nutrientesInfo)
    setOpenModalNutrientes(true);
    setAnchorEl(null);
  };
  const handleCloseModalNutrientes = () => setOpenModalNutrientes(false);

  const handleChangeNutrientesValue = (nome, value) => {
    var nutrientesData = nutrientesInfo.map(function (item, i) {
      if(item.nome == nome) {
        return {
          'nutrienteid': item.nutrienteid,
          'quantidade': value,
          'nome': item.nome
        }
      }else{
        return item
      }
    })
    setNutrientesInfo(nutrientesData)
  }

  const handleChange = (value, state) => {
    state(value)
  }

  const onClickSave = async (path) => {
    await updateUserData(userId, newAltura, newPeso)
      .then(response => {
        window.location.reload(false);
      })
      .catch(error => {
        setErrorMessage("Erro ao atualizar dados, tente novamente mais tarde")
        setOpenAlert(true)
      })
  }

  const onClickSaveNutrientes = async (path) => {
    await updateNutrientesData(userId, nutrientesInfo)
      .then(response => {
        localStorage.setItem('nutrientes', JSON.stringify(nutrientesInfo))
        window.location.reload(false);
      })
      .catch(error => {
        setErrorMessage("Erro ao atualizar dados, tente novamente mais tarde")
        setOpenAlert(true)
      })
  }

  const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenAlert(false);
  };

  return (
    <div className='home'>
      <Row>
        <Col span={24} className='home__header'>
          <img src={Logo} alt='' className='home__logo' />
          <div className='home__logout' >
            <IconButton
              aria-label="more"
              id="long-button"
              aria-controls={open ? 'long-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-haspopup="true"
              onClick={handleClick}
            >
              {
                open ?
                  <CloseIcon sx={{ color: "#29AF9C" }} />
                  :
                  <DehazeIcon sx={{ color: "#29AF9C" }} />

              }
            </IconButton>
          </div>

        </Col>
      </Row>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={() => handleOpenModal()}>Editar Perfil</MenuItem>
        <MenuItem onClick={() => handleOpenModalNutrientes()}>Editar Nutrientes Controlados</MenuItem>
        <MenuItem onClick={() => Logout()}>Sair</MenuItem>
      </Menu>
      <div className='home__body'>
        <div onClick={() => onClickMenu('/diario')} style={{ backgroundColor: '#29AF9C', height: '100%' }}>
          <img src={DiarioAlimentar} alt='' className='home__menuItem' />
        </div>
        <div onClick={() => onClickMenu('/consultar-alimentos')} style={{ backgroundColor: '#84C453', height: '100%' }}>
          <img src={ConsultarAlimentos} alt='' className='home__menuItem' />
        </div>
        <div onClick={() => onClickMenu('/cadastrar-exames')} style={{ backgroundColor: '#FE9025', height: '100%' }}>
          <img src={CadastrarExames} alt='' className='home__menuItem' />
        </div>
        {/* calcular-receitas */}
        <div onClick={() => onClickMenu('/calcular-receitas')} style={{ backgroundColor: '#74BB40', height: '100%' }}>
          <img src={CalcularReceitas} alt='' className='home__menuItem' />
        </div>
        <div onClick={() => onClickMenu('/relatorios')} style={{ backgroundColor: '#FE7518', height: '100%' }}>
          <img src={Relatorios} alt='' className='home__menuItem' />
        </div>
        <div onClick={() => onClickMenu('/lembretes')} style={{ backgroundColor: '#238B79', height: '100%' }}>
          <img src={LembretesFormula} alt='' className='home__menuItem' />
        </div>
      </div>
      <div className='home__footer'>
        <div><HomeFilled className='home__icons' /></div>
        <div><InfoCircleOutlined className='home__icons' onClick={() => onClickMenu('/info')} /></div>
        <div><PhoneFilled className='home__icons' onClick={() => onClickMenu('/sac')} /></div>
      </div>
      <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleCloseAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={handleCloseAlert} severity="error" sx={{ width: '100%' }}>{errorMessage}</Alert>
      </Snackbar>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <h2>Edição de Perfil</h2>
          <div className='home__formAltura'>
            <TextField fullWidth defaultValue={defaultAltura} onChange={(event) => handleChange(event.target.value, setNewAltura)} id="outlined-basic" label="Altura" variant="outlined" className='home__alturaField' />
          </div>
          <div className='home__formPeso'>
            <TextField fullWidth defaultValue={defaultPeso} onChange={(event) => handleChange(event.target.value, setNewPeso)} id="outlined-basic" label="Peso" variant="outlined" className='home__alturaField' />
          </div>
          <div className='home__cardLogin' onClick={() => onClickSave(`/`)}>
            Salvar Alterações
          </div>
        </Box>
      </Modal>
      <Modal
        open={openModalNutrientes}
        onClose={handleCloseModalNutrientes}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <h2>Edição de Nutrientes Controlados</h2>
          {
            nutrientesInfo.map(function (nutriente, i) {
              return (
                <div className='home__formAltura'>
                  <TextField fullWidth defaultValue={nutriente.quantidade} style={{marginBottom:10}} onChange={(event) => handleChangeNutrientesValue(nutriente.nome, event.target.value)} id="outlined-basic" label={nutriente.nome} variant="outlined" className='home__alturaField' />
                </div>
              )
            })
          }
          <div className='home__cardLogin' onClick={() => onClickSaveNutrientes(`/`)}>
            Salvar Alterações
          </div>
        </Box>
      </Modal>
    </div>
  )
}

export default Home
